import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class SpendingRequestInvoicing  {
    _originalTypeClassName = "zERP.BO.SpendingRequestInvoicing";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
SpendingRequestInvoicing.translate = translateService;
}
this.InvoiceRow = new Domain.InvoiceRowType();
this.Id = null;
this.InvoicedOn = null;
this.InvoicedAmount = null;
this.Quantity = null;
this.Invoiced = false;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
InvoicedOn:any;
InvoicedAmount:any;
Quantity:any;
Invoiced:any;
InvoiceRow:any;
SpendingRequestDetail:any;
NonDeductibleVATSpendingRequestDetail:any;
static setInvoiceRow = ($this, value) => {
var oldValue = $this.InvoiceRow;
$this.InvoiceRow = value;
if (value != null) {
if (oldValue != null && oldValue.SpendingRequestInvoicing != null) { oldValue.SpendingRequestInvoicing = null; }
if ($this.InvoiceRow.SpendingRequestInvoicing !== $this) {
Domain.InvoiceRowType.setSpendingRequestInvoicing(value, $this);
}
}
}
static setSpendingRequestDetail = ($this, value) => {
var oldValue = $this.SpendingRequestDetail;
$this.SpendingRequestDetail = value;
if (value != null) {
if (oldValue != null) {
Domain.SpendingRequestDetail.removeInvoicingInfo(oldValue, $this);
}
Domain.SpendingRequestDetail.addInvoicingInfo(value, $this);
}
}
static setNonDeductibleVATSpendingRequestDetail = ($this, value) => {
var oldValue = $this.NonDeductibleVATSpendingRequestDetail;
$this.NonDeductibleVATSpendingRequestDetail = value;
if (value != null) {
if (oldValue != null) {
Domain.SpendingRequestDetail.removeNonDeductibleVATInvoicingInfo(oldValue, $this);
}
Domain.SpendingRequestDetail.addNonDeductibleVATInvoicingInfo(value, $this);
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}